import { useMemo } from 'react'

import { driveTimeFilter } from '../featureFlags'
import useFeatureFlag from '../hooks/useFeatureFlag'
import { useListingDriveTimesQuery } from '../hooks/useQueries'

import driveTimeScope from './driveTimeScope'

// Minutes from the selected origin bucket, indexed by listing id.
// Client-only on purpose: viewer-dependent, so it must stay out of the
// SSR-seeded search document. Empty until the origin's bucket is warm.
const useListingDriveTimes = (
  listingIds: string[],
  filters: GQL_SearchFilters,
): Record<string, number> => {
  const flagEnabled = useFeatureFlag(driveTimeFilter)
  const { data } = useListingDriveTimesQuery({
    variables: { listingIds, scope: driveTimeScope(filters) },
    skip: !flagEnabled || listingIds.length === 0,
  })

  return useMemo(
    () =>
      Object.fromEntries(
        (data?.driveTimes?.listingTimes ?? []).map(({ listingId, minutes }) => [
          listingId,
          minutes,
        ]),
      ),
    [data],
  )
}

export default useListingDriveTimes
